export default {
  webApi: process.env.VUE_APP_BASEURL,
  hrmsAvatar: 'https://www.iconext.cc/HRMS/File/GetSquareImageProfile?squareImageFileName=',
}
